import { useState, useEffect } from 'react';
import appointmentsService from '../services/appointments.service';
import { components } from '../../../Api/types/openapi';

type LegalConsulationResponse = components['schemas']['LegalConsulationResponse'];

const useAppointmentDetail = (id: number | null) => {
  const [appointment, setAppointment] = useState<LegalConsulationResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!id) {
      setIsLoading(false);
      return;
    }

    const fetchAppointment = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await appointmentsService.getAppointmentById(id);
        setAppointment(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Error al cargar cita'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAppointment();
  }, [id]);

  return { appointment, isLoading, error };
};

export default useAppointmentDetail;

